import React, { useState, useEffect } from "react";
import ParagraphTag from "../../reusebale/Paragraph";
import ImageTag from "../../reusebale/imageTag";
import db from "../../../db/index.json";
import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";
import BaseUrl from "../../../constants/BaseUrl";
import NoData from "../../reusebale/noData"

const BroadCastSection = ({ onViewDetails, search }) => {
  const { broadcasts } = db;
  const { loader, loginSuccess, loginError } = useSelector(
    (state) => state.auth
  );

  const [allData, setAllData] = useState([])

  const GetAllBroadCast = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    fetch(`${BaseUrl}api/broadcast/getBroadcastByTenantId/${loginSuccess.user._id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setAllData(result.data)
        }
      })
      .catch((error) => console.error(error));
  }


  useEffect(() => {
    GetAllBroadCast()
  }, [])

  const [data, setData] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;

  const paginatedData = data.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
  };

  return (
    <div className="h-full">
      <div className="bg-white w-full rounded-lg h-[87%]">
        <div className="w-[95%] mx-auto h-full">
          <div className="flex justify-between items-center h-[12%]">
            <ParagraphTag
              content={broadcasts.heading}
              classes="text-darkColor font-popinsSemiBold text-lg"
            />
          </div>
          <div className="overflow-x-scroll w-full h-[88%] panelScroll pt-2">
            {allData?.map((item, i) => {
              if (item?.title?.toUpperCase()?.includes(search.toUpperCase()) || item?.description?.toUpperCase()?.includes(search.toUpperCase())) {
                return (
                  <div className="flex cursor-pointer items-center" onClick={() => {
                    onViewDetails(item);
                  }}>
                    <div className="w-[95%] py-2 flex items-center">
                      <ImageTag
                        classes={`w-[38px] h-[38px]`}
                        path={"/assets/daashboard/notification-color.png"}
                        altText="logo"
                      />
                      <div className="px-2">
                        <ParagraphTag
                          content={item.title}
                          classes={`text-darkColor font-popinsSemiBold text-xs `}
                        />

                        <ParagraphTag
                          content={item.description}
                          classes={`text-lightgray font-popinsRegular text-xs `}
                        />
                      </div>
                    </div>
                    <div className="w-[5%]flex justify-end">
                      <div className="w-2 h-2 bg-themeColor rounded-full">
                      </div>
                    </div>
                  </div>
                )
              }
            })}
            {allData.length === 0 && (
              <div className="w-full mt-16">
                <NoData />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center h-[13%]">
        {/* <ReactPaginate
          previousLabel="Previous"
          nextLabel="Next"
          breakLabel="..."
          pageCount={Math.ceil(data.length / itemsPerPage)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName="flex space-x-2 items-center"
          pageClassName="px-3 py-1 border rounded-md text-sm font-popinsMedium cursor-pointer"
          previousClassName="px-3 py-1 border rounded-l-md text-sm cursor-pointer font-popinsMedium"
          nextClassName="px-3 py-1 border rounded-r-md text-sm font-popinsMedium cursor-pointer font-popinsMedium"
          disabledClassName="opacity-50 !cursor-not-allowed"
          activeClassName="bg-themeColor text-white"
          breakClassName="px-3 py-1 text-sm font-popinsMedium"
        /> */}
      </div>
    </div>
  );
};

export default BroadCastSection;
